<template>
  <div id="genericSql">
    <a-collapse default-active-key="1" :bordered="false">
      <a-collapse-panel key="1" header="Display Columns">
        <a-row class="padding6">
          <a-table
                  :columns="columns"
                  :dataSource="displayColumns"
                  :pagination="Nopagination"
                  size="small"
                  :locale="tabelText"
                  :scroll="{  y: 150 }"
          >
            <!--:loading="DisplayColumnsLoading"-->
            <template
                    v-for="(item, index) in scopedSlotsArray"
                    :slot="item"
                    slot-scope="text"
            >
          <span :key="index">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span class="tableFontSize">{{
                    text === null ? "-" : text
                  }}</span>
              </template>
              <div class="tableFontSize">{{ text === null ? "-" : text }}</div>
            </a-tooltip>
          </span>
            </template>
            <img slot-scope="text" slot="operation" @click="EditColumns(text)" class="sbxs" src="../../../assets/img/ss-edit.png"  width="22" height="22">
          </a-table>
        </a-row>
      </a-collapse-panel>
      <a-collapse-panel key="2" header="SQL Parameters">
        <a-row class="padding6">
          <a-row>
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t('generic.Add') }}</span>
              </template>
              <img @click="addSqlParmet" class="sbxs" src="../../../assets/img/ss-add.png"  width="22" height="22">
            </a-tooltip>
            <a-popconfirm
                    :title="$t('generic.AreyoudeleTask')"
                    @confirm="delsteSqlParameters"
                    :okText="$t('generic.Yes')"
                    :cancelText="$t('generic.No')"
            >
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>{{ $t('generic.Delete') }}</span>
                </template>
                <img style="margin: 0 10px;" class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
              </a-tooltip>
            </a-popconfirm>
          </a-row>
          <a-row class="mt4">
            <a-table
                    :columns="columns1"
                    :dataSource="sqlParameters"
                    :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
                    :pagination="Nopagination"
                    size="small"
                    :locale="tabelText"
            >
              <!--:loading="sqlParametersLoading"-->
              <template
                      v-for="(item, index) in scopedSlotsArraySqlParmet"
                      :slot="item"
                      slot-scope="text"
              >
          <span :key="index">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span class="tableFontSize">{{
                    text === "1" || text === true
                        ? "Yes"
                        : text === "0" || text === false
                        ? "No"
                        : text === null
                            ? "-"
                            : text
                  }}</span>
              </template>
              <div class="tableFontSize">
                {{
                  text === "1" || text === true
                      ? "Yes"
                      : text === "0" || text === false
                      ? "No"
                      : text === null
                          ? "-"
                          : text
                }}
              </div>
            </a-tooltip>
          </span>
              </template>
              <img slot-scope="text" slot="operation" @click="EditSqlParamet(text)" class="sbxs" src="../../../assets/img/ss-edit.png"  width="22" height="22">
            </a-table>
          </a-row>
        </a-row>
      </a-collapse-panel>
    </a-collapse>
    <!--编辑新增按钮 Parameters-->
    <a-modal
      :title="$t('generic.SQLParameters')"
      centered
      v-model="visible"
      width="50%"
      @cancel="resettingParameters"
      :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="danger" @click="resettingParameters">{{ $t('publicLang.Clear') }}</a-button>
        <a-button type="primary" @click="getSqlPar">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="formParamet">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item :label="$t('generic.FieldName')" v-bind="subformItemLayout">
              <a-select
                showSearch
                @search="handleSearch"
                allowClear
                size="small"
                :disabled="addEditTypeDis"
                style="width: 100%"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'detailUid',
                  { initialValue: initialEditSqlPatter.fieldName }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in fieldNameSelect"
                  :value="item.detailUid"
                  :key="index"
                  >{{ item.fieldName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Condition')" v-bind="subformItemLayout">
              <a-select
                style="width: 100%"
                allowClear
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'condition',
                  { initialValue: initialEditSqlPatter.conditionKey }
                ]">
                <a-select-option
                  v-for="(item, index) in sqlSelectArray.condition"
                  :value="item.dataKey"
                  :key="index"
                  >{{ item.dataValue }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.AndOr')" v-bind="subformItemLayout">
              <a-select
                allowClear
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'andOr',
                  { initialValue: initialEditSqlPatter.andOr }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in sqlSelectArray.andOr"
                  :value="item"
                  :key="index"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Mandatory')" v-bind="subformItemLayout">
              <a-switch
                size="small"
                v-decorator="[
                  'mandatory',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      initialEditSqlPatter.mandatory === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.defaultValue')" v-bind="subformItemLayout">
              <a-textarea
                 size="small"
                :placeholder="$t('generic.defaultValue')"
                :rows="2"
                v-decorator="[
                  'defaultValue',
                  { initialValue: initialEditSqlPatter.defaultValue }
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      :title="$t('generic.DisplayColumns')"
      centered
      v-model="visibleColumns"
      width="40%"
      :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="danger" @click="resettingColumns">{{ $t('publicLang.Clear') }}</a-button>
        <a-button type="primary" @click="getDisClos">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="formColumns">
        <a-form-item :label="$t('generic.SortSeq')" v-bind="subformItemLayout">
          <a-input-number
            autocomplete="off"
            :min="1"
            :max="500"
            style="width: 100%"
            size="small"
            :placeholder="$t('publicLang.PleaseSelect')"
            v-decorator="['seq', { initialValue: EditColumnsVal.seq }]"
          />
        </a-form-item>
        <a-form-item :label="$t('generic.OrderBy')" v-bind="subformItemLayout">
          <a-select
            allowClear
            size="small"
            :placeholder="$t('publicLang.PleaseSelect')"
            v-decorator="[
              'orderBy',
              { initialValue: EditColumnsVal.orderBySeq }
            ]"
          >
            <a-select-option
              v-for="(item, index) in sqlSelectArray.orderBy"
              :value="item"
              :key="index"
              >{{ item }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import { mapState } from "vuex";
export default {
  data() {
    return {
      maskClosable: false,
      tabelText: {
        emptyText: "No record found"
      },
      scopedSlotsArray: ["fieldName", "seq", "orderBySeq"],
      scopedSlotsArraySqlParmet: [
        "condition",
        "mandatory",
        "andOr",
        "defaultValue"
      ],
      Nopagination: false,
      visible: false,
      visibleColumns: false,
      subformItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      displayColumns: [],
      sqlParameters: [],
      DisplayColumnsLoading: false,
      sqlParametersLoading: false,
      EditColumnsVal: "",
      selectedRowKeys: [],
      sqlSelectRows: [],
      fieldNameSelect: [],
      initialEditSqlPatter: {},
      addEditTypeDis: false,
      addEditFlag: "",
      sqlSelectArray: {} // 下拉数据
    };
  },
  computed: {
      columns(){
        return [
            {
                title: this.$t("generic.FieldName"),
                dataIndex: "fieldName",
                scopedSlots: { customRender: "fieldName" }
            },
            {
                title: this.$t("generic.SortSeq"),
                dataIndex: "seq",
                scopedSlots: { customRender: "seq" }
            },
            {
                title: this.$t("generic.OrderBy"),
                dataIndex: "orderBySeq",
                scopedSlots: { customRender: "orderBySeq" }
            },
            {
                title: this.$t("generic.Action"),
                scopedSlots: { customRender: "operation" }
            }
        ]
      },
      columns1(){
         return [
             {
                 title: this.$t("generic.FieldName"),
                 dataIndex: "fieldName"
             },
             {
                 title: this.$t("generic.defaultValue"),
                 dataIndex: "defaultValue",
                 scopedSlots: { customRender: "defaultValue" }
             },
             {
                 title: this.$t("generic.Condition"),
                 dataIndex: "condition",
                 scopedSlots: { customRender: "condition" }
             },
             {
                 title: this.$t("generic.Mandatory"),
                 dataIndex: "mandatory",
                 scopedSlots: { customRender: "mandatory" }
             },
             {
                 title: this.$t("generic.AndOr"),
                 dataIndex: "andOr",
                 scopedSlots: { customRender: "andOr" }
             },
             {
                 title:this.$t("generic.Action"),
                 scopedSlots: { customRender: "operation" }
             }
         ]
      },
    ...mapState(["uid"]), // 获取uid
    ...mapState(["tabs"])
  },
  beforeCreate() {
    //      注册表单
    this.formColumns = this.$form.createForm(this);
    this.formParamet = this.$form.createForm(this);
  },
  created() {
    this.initTable();
  },
  watch: {
    //      监听uid是否有值 请求对应tabs数据
    uid(val) {
      if (val != "") {
        this.initTable();
      }
    },
    tabs(val) {
      if (val == 3) {
        this.initTable();
      }
    }
  },
  methods: {
    handleSearch(val){
         if(val){
              this.$nextTick(()=>{
              this.formParamet.setFieldsValue({'detailUid': val})
              this.initialEditSqlPatter.fieldName = val
             })                                
      }
    },
    initTable() {
      this.DisplayColumnsLoading = true;
      this.sqlParametersLoading = true;
      if (this.uid === "") {
        this.DisplayColumnsLoading = false;
        this.sqlParametersLoading = false;

        this.displayColumns = []
        this.sqlParameters = []
        return;
      }
      ajax.get(api.GETSQLDETAIL, { gmcUid: this.uid }).then(res => {
        this.DisplayColumnsLoading = false;
        this.sqlParametersLoading = false;
        this.displayColumns = res.data.displayColumns;
        this.sqlParameters = res.data.sqlParameters;
      });
      ajax.get(api.GETSQLDROPDATA).then(res => {
        this.sqlSelectArray = res.data;
      });
    },

    EditSqlParamet(text) {
      this.initialEditSqlPatter = text;
      this.addEditTypeDis = true;
      this.addEditFlag = "edit";
      this.visible = true;
    },

    addSqlParmet() {
      this.initialEditSqlPatter = {};
      //      if (this.sqlSelectRows.length > 1) {
      //        this.$customMessage.warning("请选择一条父节点编辑");
      //        return;
      //      }
      //      if (this.sqlSelectRows[0]) {
      //        if (this.sqlSelectRows[0].parentDetailUid != null) {
      //          this.$customMessage.warning("请选择一条父节点编辑");
      //          return;
      //        }
      //      }

      this.addEditTypeDis = false;
      this.addEditFlag = "add";
      this.visible = true;
      let detailUidArray = [];
      if (this.sqlSelectRows.length > 0) {
        detailUidArray.push(this.sqlSelectRows[0].detailUid);
      }
        detailUidArray.push(-1)
      let params = {};
      params.gmcUid = this.uid;
      params.detailUids = detailUidArray;
      ajax.post(api.GETFIELDNAMEDROPDATA, params).then(res => {
        this.fieldNameSelect = res.data;
      });
    },

    EditColumns(text) {
      this.EditColumnsVal = text;
      this.visibleColumns = true;
    },

    getDisClos() {
      this.formColumns.validateFields((err, val) => {
        let params = val;
        params.detailUid = this.EditColumnsVal.detailUid;
        params.seq = Math.floor(params.seq);
        ajax.post(api.SAVESQLDETAIL, params).then(res => {
          if (res.code === 200) {
            this.visibleColumns = false;
            this.initTable();
          }
        });
      });
    },

    getSqlPar() {
      
      this.formParamet.validateFields((err, val) => {
        let params = val;

        if (this.addEditFlag === "add") {
          if (this.sqlSelectRows.length > 0) {
               params.parentDetailUid = this.sqlSelectRows[0].detailUid;
          }
          params.gmcUid = this.uid;
          params.mandatory = params.mandatory ? "1" : "0";
          if(! this.numberCheck(params.detailUid)){
             params.customField = params.detailUid
              params.detailUid = null;
          }
        } else {
          params.mandatory = params.mandatory ? "1" : "0";
          params.sqlUid = this.initialEditSqlPatter.sqlUid;
          if(! this.numberCheck(this.initialEditSqlPatter.detailUid)){
               params.customField = this.initialEditSqlPatter.detailUid
               params.detailUid = null;
          }else{
             params.detailUid = this.initialEditSqlPatter.detailUid
             params.customField = null
          }
        }
        ajax.post(api.SAVESQLDETAIL, params).then(res => {
          if (res.code === 200) {
            this.visible = false;
            this.formParamet.resetFields();
            this.initTable();
          } else {
            this.$customMessage.error(res.msg);
          }
        });
      });
    },

numberCheck(val){
    var reg = new RegExp(/^[0-9]*$/);
      if(reg.test(val)){
          return true;
        }
        return false;
},


    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.sqlSelectRows = selectedRows;
    },
    //      重置
    resettingColumns() {
      this.formColumns.resetFields();
    },
    resettingParameters() {
      this.formParamet.resetFields();
    },

    delsteSqlParameters() {
      let params = [];
      if (this.sqlSelectRows.length === 0) {
        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
        return;
      }
      for (let i in this.sqlSelectRows) {
        params.push(this.sqlSelectRows[i].sqlUid);
      }
      ajax.post(api.DELETESQLPARAMETERS, params).then(res => {
        if (res.code === 200) {
          this.initTable();
          this.selectedRowKeys = [];
          this.sqlSelectRows = [];
        }
      });
    }
  }
};
</script>
<style lang="less">
#genericSql {
  margin-top: 10px;
  .ant-card-extra {
    float: left;
    margin-left: 10px;
  }
  .ant-card-head-title {
    flex: inherit;
  }
  .ant-card-extra {
    padding: 0;
  }
}
</style>
